import { apiClient, ApiResponse } from './client';

const API_URL = '/instacart';

export const requestVerificationCode = async (session_id: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: `${API_URL}/send_code`,
    data: { session_id }
  });
};

export const verifyVerificationCode = async (session_id: string, code: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: `${API_URL}/sync`,
    data: { session_id, code }
  });
};

export const requestEmailVerificationCode = async (session_id: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: `${API_URL}/email/send_code`,
    data: { session_id }
  });
};

export const syncEmailVerificationCode = async (session_id: string, code: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: `${API_URL}/email/sync`,
    data: { session_id, code }
  });
};

export const checkCredentials = async (session_id: string, platform: string = 'instacart'): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/credentials',
    data: { session_id, platform }
  });
}; 